import React, { useMemo } from 'react';
import { IconChevronLeftOffsetLTR, IconArrowLeftLTR } from '@byted-tiktok/tux-icons';
import { useTUXContext } from '../TUXProvider/TUXProvider.js';
import { TUXNavBarIconAction } from './TUXNavBarIconAction.js';

var _ref2 = /*#__PURE__*/React.createElement(IconChevronLeftOffsetLTR, null);

var _ref3 = /*#__PURE__*/React.createElement(IconArrowLeftLTR, null);

var TUXNavBarBackAction = function TUXNavBarBackAction(_ref) {
  var onClick = _ref.onClick;

  var _useTUXContext = useTUXContext(),
      platform = _useTUXContext.platform;

  var icon = useMemo(function () {
    if (platform === 'iOS') {
      return _ref2;
    } else {
      return _ref3;
    }
  }, [platform]);
  return /*#__PURE__*/React.createElement(TUXNavBarIconAction, {
    icon: icon,
    onClick: onClick
  });
};

export { TUXNavBarBackAction };
//# sourceMappingURL=TUXNavBarBackAction.js.map
